import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9439049c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-queue" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u dit bestand wilt verwijderen?", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u dit bestand wilt verwijderen?", -1))

import { ref, watchEffect, withDefaults } from 'vue'
import { FileImageOutlined } from '@ant-design/icons-vue'

export interface Props {
  mediaItems?: { name:string, url:string }[]
  files?: File[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadQueue',
  props: {
    mediaItems: { default: () => [] },
    files: { default: () => [] }
  },
  emits: ['fileDeleted'],
  setup(__props: any, { emit }) {

const props = __props as { mediaItems: { name:string, url:string }[], files: File[] };




const filesWithPreview = ref<{ name:string, preview: string|null }[]>([])

function deleteMediaItem (index:number) : void {
  emit('fileDeleted', index)
}

const updateFilesWithPreview = async () => {
  const promises = props.files.map(async (file) => ({
    name: file.name,
    preview: await generatePreviewFile(file)
  }))

  filesWithPreview.value = await Promise.all(promises)
}

const generatePreviewFile = async (file) => {
  if (file.type.includes('image')) {
    return getBase64(file)
  } else if (file.type.includes('video')) {
    return createThumbnail(file)
  } else {
    return null
  }
}

watchEffect(() => {
  if (props.files && props.files.length) {
    updateFilesWithPreview()
  } else {
    filesWithPreview.value = []
  }
})

function getBase64 (file:File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = error => reject(error)
    reader.readAsDataURL(file)
  })
}

const createThumbnail = async (file:File) => {
  const video = document.createElement('video')
  video.src = URL.createObjectURL(file)
  video.load()
  await new Promise((resolve) => {
    video.onloadeddata = resolve
  })

  const canvas = document.createElement('canvas')
  canvas.width = video.videoWidth
  canvas.height = video.videoHeight
  canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
  return canvas.toDataURL()
}

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.mediaItems && __props.mediaItems.length)
      ? (_openBlock(), _createBlock(_component_a_list, {
          key: 0,
          "item-layout": "horizontal",
          "data-source": __props.mediaItems,
          size: "small"
        }, {
          renderItem: _withCtx(({ item, index }) => [
            _createVNode(_component_a_list_item, null, {
              actions: _withCtx(() => [
                _createVNode(_component_a_popconfirm, {
                  placement: "topRight",
                  "ok-text": "Ja",
                  "cancel-text": "Nee",
                  onConfirm: ($event: any) => (deleteMediaItem(index))
                }, {
                  title: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Verwijderen ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_list_item_meta, null, {
                  avatar: _withCtx(() => [
                    _createVNode(_component_a_avatar, {
                      shape: "square",
                      style: { backgroundColor: '#f38929' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FileImageOutlined))
                      ]),
                      _: 1
                    })
                  ]),
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data-source"]))
      : (filesWithPreview.value && filesWithPreview.value.length)
        ? (_openBlock(), _createBlock(_component_a_list, {
            key: 1,
            "item-layout": "horizontal",
            "data-source": filesWithPreview.value,
            size: "small"
          }, {
            renderItem: _withCtx(({ item, index }) => [
              _createVNode(_component_a_list_item, null, {
                actions: _withCtx(() => [
                  _createVNode(_component_a_popconfirm, {
                    placement: "topRight",
                    "ok-text": "Ja",
                    "cancel-text": "Nee",
                    onConfirm: ($event: any) => (deleteMediaItem(index))
                  }, {
                    title: _withCtx(() => [
                      _hoisted_3
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Verwijderen ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_list_item_meta, null, {
                    avatar: _withCtx(() => [
                      _createVNode(_component_a_avatar, {
                        shape: "square",
                        src: item.preview,
                        style: { backgroundColor: '#f38929' }
                      }, {
                        default: _withCtx(() => [
                          (!item.preview)
                            ? (_openBlock(), _createBlock(_unref(FileImageOutlined), { key: 0 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["src"])
                    ]),
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["data-source"]))
        : _createCommentVNode("", true)
  ]))
}
}

})